import { getToken } from "../../setup/api";

export default {
  user: null,
  messages: [],
  logged: !!getToken()
};
